<ngx-spinner bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
    <h6>Processando...</h6>
</ngx-spinner>

<div class="section">
    <div class="config-area">
        <div class="header">
            <div class="config-title">
                <div class="title-container">
                    <h3 class="title m-0">
                        <span class="label">Fluxos Instanciados (por Caixa de Fluxo)</span>
                    </h3>
                </div>
            </div>
        </div>

        <hr />

        <h5 class="subtitle mb-3">Adicionar critérios para filtragem</h5>

        <!-- Filtro -->
        <div class="config-inputs">
            <div class="predefined-filter-search ml-4">
                <!-- Identificação -->
                <div class="predefined-filter-section mt-3" [class.closed]="!$isShowingFlowInfoSection()">
                    <div class="title text-highlight info-font" (click)="toggleFlowInfoSection()" (keyDown)="toggleFlowInfoSection()">
                        <i class="toggle-section fas fa-chevron-circle-right mr-1" [class.on]="$isShowingFlowInfoSection()"></i>
                        <span>Identificação</span>
                        <i class="toggle-section fas fa-chevron-circle-left ml-1" [class.on]="$isShowingFlowInfoSection()"></i>
                    </div>

                    <div class="section-content" [class.invisible]="!$isShowingFlowInfoSection()">
                        <div class="keep-left">
                            <!-- Caixa de Fluxos -->
                            <div class="form-group m-0">
                                <label for="selectedFlowInbox">Caixa de Fluxos <b style="color: red">*</b></label>

                                <ngx-select-dropdown [ngModel]="$selectedFlowInboxObject()"
                                                     [config]="selectedFlowInboxConfig"
                                                     [options]="getOrderedFlowInboxesList()"
                                                     (change)="changeFlowInbox($event.value)"
                                                     (open)="openFlowInbox()"
                                ></ngx-select-dropdown>
                            </div>

                            <!-- Fluxo -->
                            <div class="form-group mb-0 ml-3">
                                <label for="selectedFlowDefinition">Fluxo</label>
                                <select class="form-control" id="selectedFlowDefinition"
                                        [disabled]="$selectedFlowInbox() == null"
                                        [ngModel]="$selectedFlowDefinition()"
                                        (change)="getVersions($event.target.value)"
                                >
                                    <option value="null"></option>

                                    @for (item of getOrderedFlowDefinitionsList(); track item) {
                                        <option [value]="item.id">{{item.name}}</option>
                                    }
                                </select>
                            </div>

                            <!-- Versão -->
                            <div class="form-group mb-0 ml-3">
                                <label for="selectedVersion">Versão</label>
                                <select class="form-control" id="selectedVersion"
                                        [disabled]="$selectedFlowDefinition() == null"
                                        [ngModel]="$selectedVersion()"
                                        (change)="$selectedVersion.set($event.target.value)"
                                >
                                    <option value="null"></option>

                                    @for (item of $filteredVersions(); track item) {
                                        <option [value]="item">{{item}}</option>
                                    }
                                </select>
                            </div>
                        </div>

                        <!-- Adicionar critério -->
                        <button type="button" class="btn btn-outline-primary py-0 px-2 ml-3"
                                matTooltip="Adicionar critério"
                                [disabled]="$selectedFlowInbox() == null"
                                (click)="addFlowInfoFilterCriteria()"
                                (keyDown)="addFlowInfoFilterCriteria()"
                        >
                            <i class="fas fa-plus-circle mr-1"></i>
                            <span>Adicionar critério</span>
                        </button>

                        <!-- Limpar -->
                        <button type="button" class="btn btn-outline-danger py-0 px-2 ml-1"
                                matTooltip="Limpar valores"
                                [disabled]="$selectedFlowInbox() == null"
                                (click)="clearFlowInfoFilterCriteria()"
                                (keyDown)="clearFlowInfoFilterCriteria()"
                        >
                            <i class="fas fa-times-circle mr-1"></i>
                            <span>Limpar</span>
                        </button>
                    </div>
                </div>

                @if (getSearchTokensFlowInfo().length == 0) {
                    <div class="chip-container mt-3">
                        <div class="chip default-filter">
                            <span>Sem Filtros</span>
                        </div>
                    </div>
                }

                @for (timestamp of getFlowInfoTimestamps(); track timestamp; let i = $index) {
                    <div class="chip-container" [class.mt-3]="i == 0" [class.mt-2]="i > 0">
                        @if (getFlowInfoTimestamps().length > 1) {
                            <div class="or-statement text-highlight" [class.invisible]="i == 0">OU</div>
                        }

                        @for (searchToken of getSearchTokensFlowInfo(timestamp); track searchToken) {
                            <div class="chip">
                                <span>{{searchToken.text}}</span>
                                <i class="icon fas fa-times-circle ml-1"
                                   matTooltip="Remover filtro"
                                   (click)="removeFilter(searchToken)"
                                   (keyDown)="removeFilter(searchToken)"
                                ></i>
                            </div>
                        }
                    </div>
                }

                <!-- Data de Encerramento -->
                <div class="predefined-filter-section flex-column align-items-start mt-5" [class.closed]="!$isShowingFinishDateSection()">
                    <div class="title text-highlight info-font" (click)="toggleFinishDateSection()" (keyDown)="toggleFinishDateSection()">
                        <i class="toggle-section fas fa-chevron-circle-right mr-1" [class.on]="$isShowingFinishDateSection()"></i>
                        <span>Data de Encerramento</span>
                        <i class="toggle-section fas fa-chevron-circle-left ml-1" [class.on]="$isShowingFinishDateSection()"></i>
                    </div>

                    <!-- Intervalo predeterminado -->
                    <div class="subtitle info-font my-2" [class.invisible]="!$isShowingFinishDateSection()">• Intervalo predeterminado:</div>

                    <div class="section-content" [class.invisible]="!$isShowingFinishDateSection()">
                        <div class="predefined-datetime button-text ml-4">
                            <button type="button" class="btn btn-outline-primary py-0 px-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Today)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Today)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Hoje</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last24)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last24)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 24h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last48)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last48)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 48h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last72)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last72)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 72h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastWeek)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastWeek)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Última semana</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastFortnight)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastFortnight)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Última quinzena</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastMonth)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastMonth)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Último mês</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastYear)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastYear)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Último ano</span>
                            </button>
                        </div>
                    </div>

                    <!-- Intervalo customizado -->
                    <div class="subtitle info-font mt-3" [class.invisible]="!$isShowingFinishDateSection()">• Intervalo customizado:</div>

                    <div class="section-content" [class.invisible]="!$isShowingFinishDateSection()">
                        <div class="custom-datetime ml-4">
                            <div class="keep-left">
                                <div class="form-group mb-0">
                                    <label for="selectedFromDateTime">De</label>
                                    <div class="d-flex">
                                        <datetime-picker [value]="$selectedFromDateTime()" (valueChange)="$selectedFromDateTime.set($event)"></datetime-picker>
                                    </div>
                                </div>

                                <div class="form-group mb-0 ml-3">
                                    <label for="selectedUntilDateTime">Até</label>
                                    <div class="d-flex">
                                        <datetime-picker [value]="$selectedUntilDateTime()" (valueChange)="$selectedUntilDateTime.set($event)"></datetime-picker>
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-3"
                                    matTooltip="Adicionar critério"
                                    [disabled]="$selectedFromDateTime() == null && $selectedUntilDateTime() == null"
                                    (click)="addPredefinedFinishDateFilterCriteria()"
                                    (keyDown)="addPredefinedFinishDateFilterCriteria()"
                            >
                                <i class="fas fa-plus-circle mr-1"></i>
                                <span>Adicionar critério</span>
                            </button>

                            <button type="button" class="btn btn-outline-danger py-0 px-2 ml-1"
                                    matTooltip="Limpar valores"
                                    [disabled]="$selectedFromDateTime() == null && $selectedUntilDateTime() == null"
                                    (click)="clearFinishDateFilterCriteria()"
                                    (keyDown)="clearFinishDateFilterCriteria()"
                            >
                                <i class="fas fa-times-circle mr-1"></i>
                                <span>Limpar</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="chip-container mt-3">
                    @if (getSearchTokensFinishDate().length == 0) {
                        <div class="chip default-filter">
                            <span>Sem Filtros</span>
                        </div>
                    } @else {
                        @for (searchToken of getSearchTokensFinishDate(); track searchToken) {
                            <div class="chip">
                                <span>{{searchToken.text}}</span>
                                <i class="icon fas fa-times-circle ml-1"
                                   matTooltip="Remover filtro"
                                   (click)="removeFilter(searchToken)"
                                   (keyDown)="removeFilter(searchToken)"
                                ></i>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>

        <!-- Ações -->
        <div class="actions">
            <!-- Mostrar estatísticas -->
            <button type="button" class="btn btn-outline-primary"
                    [disabled]="shouldDisableSearch()"
                    (click)="getResults()"
                    (keyDown)="getResults()"
            >
                <i class="fas fa-chart-bar mr-2"></i>
                <span>Mostrar estatísticas</span>
            </button>

            <!-- Exportar CSV -->
            <button type="button" class="btn btn-outline-primary"
                    [disabled]="shouldDisableSearch()"
                    (click)="exportCsv()"
                    (keyDown)="exportCsv()"
            >
                <i class="fas fa-file-csv mr-2"></i>
                <span>Exportar dados em formato CSV</span>
            </button>
        </div>
    </div>

    <!-- Estatísticas -->
    @if ($filteredResults() != null) {
        <div class="results-area" id="flow-instance-results-area" #flowInstanceResultsAreaRef>
            <hr />

            <div class="results-area-section counters mt-3">
                <dashboard-item class="w-33"
                                [_counter]="$filteredResults().countFinishedFlowInstances"
                                [_counterLabel]="FlowInstancesByInboxDescription.get('countFinishedFlowInstances')"
                ></dashboard-item>
                <dashboard-item class="w-33"
                                [_counter]="$filteredResults().averageFinishedFlowInstancesDay"
                                [_counterLabel]="FlowInstancesByInboxDescription.get('averageFinishedFlowInstancesDay')"
                ></dashboard-item>
                <dashboard-item class="w-33"
                                [_counter]="$filteredResults().averageFlowInstanceFinishingTimeSecondsProcessed"
                                [_counterLabel]="FlowInstancesByInboxDescription.get('averageFlowInstanceFinishingTimeSeconds')"
                ></dashboard-item>
            </div>

            <div class="results-area-section mt-5">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Porcentagem de Fluxos executados por dia da semana no período</label>
                    <ngx-charts-bar-vertical xAxisLabel="Dia"
                                             yAxisLabel="%"
                                             legendTitle=""
                                             [view]="[500, 400]"
                                             [results]="$percentagePerWeekdayResults()"
                                             [xAxis]="true"
                                             [showXAxisLabel]="false"
                                             [yAxis]="true"
                                             [showYAxisLabel]="true"
                                             [legend]="false"
                                             [gradient]="true"
                                             [showDataLabel]="true"
                    ></ngx-charts-bar-vertical>
                </div>

                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="anotherChart">Porcentagem de Fluxos executados por hora do dia no período</label>
                    <ngx-charts-bar-vertical xAxisLabel="Hora"
                                             yAxisLabel="%"
                                             legendTitle=""
                                             [view]="[830, 400]"
                                             [results]="$percentagePerDayHourResults()"
                                             [xAxis]="true"
                                             [showXAxisLabel]="false"
                                             [yAxis]="true"
                                             [showYAxisLabel]="true"
                                             [legend]="false"
                                             [gradient]="true"
                                             [showDataLabel]="true"
                    ></ngx-charts-bar-vertical>
                </div>
            </div>
        </div>
    }
</div>
